/**
 * @param {string | HTMLElement | JQuery} elemOrSelector
 *
 * @returns {Promise<import('filepond').FilePond>}
 */
mpro.getFilepondInstance = async (elemOrSelector, optionsDataAttribute = 'ajax-upload') => {

	/** @type {JQuery<HTMLInputElement>} */// @ts-ignore
	const $element = $(elemOrSelector);

	if ($element.length === 0) {
		throw new Error('No element found for selector: ' + elemOrSelector);
	}
	else if ($element[0].tagName !== 'INPUT') {
		throw new Error('Element must be an input element');
	}

	return import('./mpro.file-upload.js').then(({ decorateAjaxUploadInput }) => decorateAjaxUploadInput($element[0], $element.data(optionsDataAttribute) || {}));
};


export default mpro;